// extracted by mini-css-extract-plugin
export default {"label_spec":"TriStateAnswer_label_spec__8q2yh","tristate":"TriStateAnswer_tristate__-bEyF","tristate_btn":"TriStateAnswer_tristate_btn__rBMgz"};